export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
                  瓜
                </span>
                <span className="font-heading text-xl text-background-50">吃瓜群</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                吃瓜群众在线爆料平台，提供最新内幕、实时爆料和在线爆料大全内容。满足你对娱乐圈突发事件的深层好奇，做靠谱的吃瓜群众在线聚集地。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                合作信息持续更新中，敬请期待。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                快速链接
              </h4>
              <div className="flex flex-col gap-2">
                <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">吃瓜热度榜</a>
                <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新快讯</a>
                <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">话题标签</a>
                <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 吃瓜群 - 吃瓜群众在线爆料平台。内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>实时吃瓜爆料更新</span>
              <span>·</span>
              <span>在线爆料大全</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}